<se-fe-card class="commerce-list-card" id="bundle-list">
  <se-fe-card-header seFeDataTitle="Bundles" [seFeDataDivider]="true">
    <div seFeCardHeaderActions>
      <div class="commerce-list-actions__desktop">
        <se-fe-button (click)="createProductBundle()" seFeDataEmphasis="low">Create bundle</se-fe-button>
      </div>

      <se-fe-icon-button class="commerce-list-actions__mobile" [seFeMenuTrigger]="mobileMenu">
        <se-fe-icon
          seFeDataName="more_vertical"
          seFeDataSize="900"
          seFeDataAriaLabel="Open bundle actions menu"></se-fe-icon>
      </se-fe-icon-button>
      <se-fe-menu #mobileMenu [seFeDataOptions]="mobileMenuOptions">
        <div class="se-fe-menu__card-menu-form commerce-list-mobile-menu__actions" seFeMenuContent>
          <se-fe-button (click)="createProductBundle()" seFeDataEmphasis="low">Create bundle</se-fe-button>
        </div>
      </se-fe-menu>
    </div>
  </se-fe-card-header>

  <se-fe-card-content>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <product-table
          [mode]="'bundleList'"
          (queryChanged)="queryChanged($event)"
          (toggleActiveStatus)="toggleActiveStatus($event)"
          [active]="active$ | async"
          [catalogId]="catalogId$ | async"
          [loading]="bundlesLoading$ | async"
          [products]="bundles$ | async"
          [paginationEnabled]="true"
          [paginationOptions]="paginationOptions$ | async"
          [showSearch]="true"
          [sortBy]="sortBy$ | async"
          [sortDirection]="sortDirection$ | async"
          [showDelete]="false"
          [query]="queryString$ | async"></product-table>
      </se-fe-grid-cell>
    </se-fe-grid>
  </se-fe-card-content>
</se-fe-card>
